// @ts-nocheck
import {
    createStore, createTypedHooks,
} from 'easy-peasy';

import storyboards, {StoryboardsModel} from 'views/storyboard/stores/storyboard';
import storyboardGridAnimation, {StoryboardGridAnimationModel} from 'views/storyboard/stores/storyboardGridAnimation';
import activeStoryboard, {ActiveStoryboardModel} from 'views/storyboard/stores/activeStoryboard';
import activeDummyStory, {ActiveDummyStorySlugModel} from 'views/storyboard/stores/activeDummyStory';
import activeDummyStoryboard from 'views/storyboard/stores/activeDummyStoryboard';

import actionsStore from 'views/admin/stores/action';
import searchStore, {SearchStoreModel} from 'views/search/stores/search';
import searchIndexDataStore from 'views/admin/stores/searchIndex';
import rulesStore from 'views/admin/stores/rule';
import tasksStore from 'views/tasks/stores/task';
import eventsStore from 'views/events/stores/event';
import type {EventStore} from 'views/events/stores/event';
import userActivityStore from 'views/users/stores/user_activity';
import userLoginsStore from 'views/users/stores/user_logins';
import userApiLoginsStore from 'views/users/stores/user_api_logins';
import userPreferencesStore from 'views/settings/stores/user_preferences';
import customizeFormFieldChoicesStore from './views/admin/stores/customizeFormFieldChoices';
import sortTypeFieldChoicesStore from './views/admin/stores/sortTypeFieldChoices';
import viewTypeFieldChoicesStore from './views/admin/stores/viewTypeFieldChoices';
import eventFiltersStore from './views/admin/stores/eventFilters';
import eventDetailStore from './views/event_detail/stores/eventDetail';
import metricTimelineTypesStore from './views/admin/stores/metricTimelineTypes';
import userDataStore, {UserModel} from './utils/user';
import {
    simpleBooleanStoreFactory,
    SimpleBooleanStoreModel,
    simpleCrudStoreFactory,
    SimpleCrudStoreModel
} from 'utils/storeFactories';
import activeStoryObject, {ActiveStoryObjectModel} from './views/storyboard/stores/activeStoryObject';
import filterSidebarOpen, {FilterSidebarOpenModel} from './views/storyboard/stores/filterSidebarOpen';
import tableChartDownloadCallbacks, {TableChartDownloadCallbacksModel} from './views/storyboard/stores/tableChartDownloadCallbacks';
import stories, {StoriesStoreModel} from './views/storyboard/stores/stories';
import notifications from './views/admin/stores/notifications';
import qualityAssuranceData from './views/admin/stores/qualityAssuranceData';
import qualityAssuranceDataReport from './views/admin/stores/qualityAssuranceDataReport';
import activePage, {ActivePageStoreModel} from './routing/stores/activePage';
import sidebarMenu, {SidebarMenuModel} from './components/sidebar/stores/sidebarMenu';
import {Story} from 'entities/story';
import myNotifications from './views/admin/stores/myNotifications';
import appConfigStore from './utils/appConfigStore';


export interface StoreModel {
    appConfigs: any;
    stories: StoriesStoreModel;
    notifications: any;
    myNotifications: any;
    qualityAssuranceData: any;
    qualityAssuranceDataReport: any;
    storyboards: StoryboardsModel;
    publicStories: SimpleCrudStoreModel<Story>;
    conversationStories: SimpleCrudStoreModel<Story>;
    personsStories: SimpleCrudStoreModel<Story>;
    storyboardGridAnimation: StoryboardGridAnimationModel;
    activeDummyStory: ActiveDummyStorySlugModel;
    activeDummyStoryboard: any;
    activeStoryboard: ActiveStoryboardModel;
    activeStoryObject: ActiveStoryObjectModel;
    tableChartDownloadCallbacks: TableChartDownloadCallbacksModel;
    chats: any;
    customers: SimpleCrudStoreModel<any>;
    agents: SimpleCrudStoreModel<any>;
    agentsAssignUser: SimpleCrudStoreModel<any>;
    teams: SimpleCrudStoreModel<any>;
    apiTokens: SimpleCrudStoreModel<any>;
    dictionaries: SimpleCrudStoreModel<any>;
    configurations: SimpleCrudStoreModel<any>;
    users: SimpleCrudStoreModel<any>;
    usersAssignAgent: SimpleCrudStoreModel<any>;
    evaluations: SimpleCrudStoreModel<any>;
    roles: SimpleCrudStoreModel<any>;
    permissions: SimpleCrudStoreModel<any>;
    auditLogs: SimpleCrudStoreModel<any>;
    usersActivity: any;
    usersLogins: any;
    usersApiLogins: any;
    userPreferences: any;
    actions: any;
    search: SearchStoreModel;
    rules: any;
    tasks: any;
    events: EventStore;
    eventDetail: any;
    filterSidebarOpen: FilterSidebarOpenModel;
    channels: SimpleCrudStoreModel<any>;
    backgroundTasks: SimpleCrudStoreModel<any>;
    audioAnonymizationTasks: SimpleCrudStoreModel<any>;
    transcriptionTasks: SimpleCrudStoreModel<any>;
    transcriptionTasksNotSent: SimpleCrudStoreModel<any>;
    transcriptionTasksInTranscription: SimpleCrudStoreModel<any>;
    channelEvaluationsTasks: any;
    evaluationTaskTypeChoices: any;
    customizeFormFieldChoices: any;
    langFieldChoices: any;
    additionalAppsChoices: any;
    dictionaryTypeFieldChoices: any;
    tagFieldChoices: any;
    partsToEvaluateChoices: any;
    eventTypeFieldChoices: any;
    notificationsScheduleFieldChoices: any;
    sortTypeFieldChoices: any;
    viewTypeFieldChoices: any;
    eventFilters: any;
    metricTimelineTypes: any;
    userData: UserModel;
    queryHelpModal: SimpleBooleanStoreModel<'queryHelpModalOpen'>;
    emailFetchCredentials: SimpleCrudStoreModel<any>;
    emailFetchAccounts: SimpleCrudStoreModel<any>;
    emailFetchTasks: SimpleCrudStoreModel<any>;
    settingsModalOpen: SimpleBooleanStoreModel<'settingsModalOpen'>;
    activePage: ActivePageStoreModel;
    sidebarMenu: SidebarMenuModel;
    activeStoryObjectDetails: any;
    activeObjectDetails: any;
}


const store = createStore<StoreModel>({
    appConfigs: appConfigStore,
    stories,
    notifications,
    myNotifications,
    storyboards,
    publicStories: simpleCrudStoreFactory(),
    conversationStories: simpleCrudStoreFactory(),
    personsStories: simpleCrudStoreFactory(),
    storyboardGridAnimation,
    activeDummyStory,
    activeDummyStoryboard,
    activeStoryboard,
    activeStoryObject,
    tableChartDownloadCallbacks,
    customers: simpleCrudStoreFactory(),
    agents: simpleCrudStoreFactory(),
    agentsAssignUser: simpleCrudStoreFactory(),
    teams: simpleCrudStoreFactory(),
    apiTokens: simpleCrudStoreFactory(),
    dictionaries: simpleCrudStoreFactory(),
    configurations: simpleCrudStoreFactory(),
    users: simpleCrudStoreFactory(),
    usersAssignAgent: simpleCrudStoreFactory(),
    evaluations: simpleCrudStoreFactory(),
    roles: simpleCrudStoreFactory(),
    permissions: simpleCrudStoreFactory(),
    auditLogs: simpleCrudStoreFactory(),
    usersActivity: userActivityStore,
    usersLogins: userLoginsStore,
    usersApiLogins: userApiLoginsStore,
    userPreferences: userPreferencesStore,
    actions: actionsStore,
    search: searchStore,
    searchIndexData: searchIndexDataStore,
    qualityAssuranceData,
    qualityAssuranceDataReport,
    rules: rulesStore,
    tasks: tasksStore,
    events: eventsStore,
    eventDetail: eventDetailStore,
    filterSidebarOpen,
    channels: simpleCrudStoreFactory(),
    backgroundTasks: simpleCrudStoreFactory(),
    audioAnonymizationTasks: simpleCrudStoreFactory(),
    transcriptionTasks: simpleCrudStoreFactory(),
    transcriptionTasksNotSent: simpleCrudStoreFactory(),
    transcriptionTasksInTranscription: simpleCrudStoreFactory(),
    channelEvaluationsTasks: simpleCrudStoreFactory(),
    evaluationTaskTypeChoices: simpleCrudStoreFactory(),
    customizeFormFieldChoices: customizeFormFieldChoicesStore,
    langFieldChoices: simpleCrudStoreFactory(),
    additionalAppsChoices: simpleCrudStoreFactory(),
    dictionaryTypeFieldChoices: simpleCrudStoreFactory(),
    tagFieldChoices: simpleCrudStoreFactory(),
    partsToEvaluateChoices: simpleCrudStoreFactory(),
    eventTypeFieldChoices: simpleCrudStoreFactory(),
    notificationsScheduleFieldChoices: simpleCrudStoreFactory(),
    sortTypeFieldChoices: sortTypeFieldChoicesStore,
    viewTypeFieldChoices: viewTypeFieldChoicesStore,
    eventFilters: eventFiltersStore,
    metricTimelineTypes: metricTimelineTypesStore,
    userData: userDataStore,
    queryHelpModal: simpleBooleanStoreFactory('queryHelpModalOpen'),
    emailFetchCredentials: simpleCrudStoreFactory(),
    emailFetchAccounts: simpleCrudStoreFactory(),
    emailFetchTasks: simpleCrudStoreFactory(),
    settingsModalOpen: simpleBooleanStoreFactory('settingsModalOpen'),

    activePage,
    sidebarMenu,
    activeStoryObjectDetails: simpleCrudStoreFactory(),
    activeObjectDetails: simpleCrudStoreFactory(),
});

const typedHooks = createTypedHooks<StoreModel>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;


export default store;
